/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import MoserObject from './MoserObject';
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper

/**
 * wrapper object to support mixed folders and references in the user defined order. <p>Java class for folderItemType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="folderItemType"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;choice&gt; &lt;element name="folder" type="{}folderType" minOccurs="0"/&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="defLink" type="{}defLinkType" minOccurs="0"/&gt; &lt;/choice&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class FolderItemType extends MoserObject{

	folder = null;

	ref = null;

	defLink = null;

	_referencedObject = null;



	/**
	 * Gets the value of the folder property.
	 * @return {FolderType} possible object is {@link FolderType}
	 */
	getFolder() {
		return this.folder;
	}

	/**
	 * Sets the value of the folder property.
	 * @param {FolderType} value allowed object is {@link FolderType}
	 */
	setFolder(value) {
		var oldValue = this.folder;
		this.folder = value;
		this._setAndNotify(29, oldValue, value, true, false);
	}

	/**
	 * Gets the value of the ref property.
	 * @return {String} possible object is {@link String}
	 */
	getRef() {
		return this.ref;
	}

	/**
	 * Sets the value of the ref property.
	 * @param {String} value allowed object is {@link String}
	 */
	setRef(value) {
		var oldValue = this.ref;
		this.ref = value;
		this._setAndNotify(36, oldValue, value, false, false);
		this._referencedObject = null;
	}

	/**
	 * Gets the value of the defLink property.
	 * @return {DefLinkType} possible object is {@link DefLinkType}
	 */
	getDefLink() {
		return this.defLink;
	}

	/**
	 * Sets the value of the defLink property.
	 * @param {DefLinkType} value allowed object is {@link DefLinkType}
	 */
	setDefLink(value) {
		var oldValue = this.defLink;
		this.defLink = value;
		this._setAndNotify(79, oldValue, value, true, false);
	}

	/**
	 * Creates a new instance of <code>FolderItemType</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> FolderItemType</code> object from.
	 * @return {FolderItemType} an object of type <code>FolderItemType</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createFolderItemType();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "FolderItemType";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		var clazz;
		if (factory) {
			clazz = factory.createFolderType().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 29, "folder", clazz));
		featureList.push(this.createFeature(false, false, false, 36, "ref", null));
		if (factory) {
			clazz = factory.createDefLinkType().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 79, "defLink", clazz));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 36:
			this.setRef((value));
			break;
		case 29:
			this.setFolder((value));
			break;
		case 79:
			this.setDefLink((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 36:
			return this.getRef();
		case 29:
			return this.getFolder();
		case 79:
			return this.getDefLink();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 36:
			return this.getRef();
		case 29:
			return this.getFolder();
		case 79:
			return this.getDefLink();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Set the resolved object based on reference.
	 * @param {MoserObject} referencedObject the referenced <code>MoserObject</code>
	 */
	setReferencedObject(referencedObject) {
		this._referencedObject = referencedObject;
	}

	/**
	 * Get the resolved object based on reference.
	 * @return {MoserObject} the referenced <code>MoserObject</code>
	 */
	getReferencedObject() {
		return this._referencedObject;
	}

	clone() {
		var cloned = (super.clone());
		cloned.setReferencedObject(this._referencedObject);
		return cloned;
	}
}


// WEBPACK FOOTER //
// ./src/generated/FolderItemType.js